export default {
  sidebar: {
    switchSide: 'Switch side'
  }
}
